/**
 * Authentication Store — re-export from auth module
 *
 * This file preserves the import path for existing consumers.
 * All auth logic now lives in src/auth/ (XState machine + adapter pattern).
 */

export { useAuthStore, initializeAuth, getAuthProvider } from '../auth';
